import {HttpAxiosRequest} from 'src/http/httpAxiosBase';

const getEndpoint = (idOperacion: number, url = '') => 
    `/operaciones/${idOperacion}/informe${url}`;

export type ReimpresionInformeRequest = {
    tinCodSistemaPrincipal: number;
    sinCodSistema: number;
    intIdMensaje: number;
}

export const HttpOperacionInforme = {
    descargarInforme: (idOperacion: number, codSistema: number): Promise<any> =>
        HttpAxiosRequest.getBlob(
            getEndpoint(idOperacion, `/descargar`),
            {
                sistema: codSistema
            }),
    reimprimirInforme: (request: ReimpresionInformeRequest): Promise<any> =>
        HttpAxiosRequest.post('/operaciones/informe/reimprimir', request),
}
